import { render, staticRenderFns } from "./PortalModules.vue?vue&type=template&id=e4177c76&"
import script from "./PortalModules.vue?vue&type=script&lang=js&"
export * from "./PortalModules.vue?vue&type=script&lang=js&"
import style0 from "./PortalModules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports